import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/browser';
import App from './adapters/primary/react/App';
import reportWebVitals from './reportWebVitals';
import store from './redux/startupScript';

Sentry.init({ dsn: 'https://19521a074351472db2c0cd32686748c8@s.bbtls.autobiz.pro/25' });

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <>
        <Provider store={store}>
            <App />
        </Provider>
    </>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(cnsole.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
